<i18n src="./ProductList.txt" lang="yaml"></i18n>
<style src="./ProductList.scss" lang="scss">

</style>
<script src="./ProductList.js"></script>

<template>
  <div class="shop-area pb-100">
    <div v-if="error">
      <pre>{{ JSON.stringify(error, undefined, 2) }}</pre>
    </div>
    <Toast v-if="toastMessage" :message="toastMessage" :type="toastType" />

    <Spinner v-if="loading" />
    <div class="custom-container">
      <ais-instant-search v-if="storeId" :search-client="searchClient" :index-name="storeId" style="width: 100%;">
        <!-- <ais-search-box placeholder="Product, brand, color, �"></ais-search-box> -->
        <ais-configure v-if="haveRouteParam === true" :hitsPerPage="45" :query="searchQuery" />
        <ais-configure v-else :query="searchQuery" />
        <ais-refinement-list attribute="masterVariant.scopedPrice.country" />
        <!-- <ais-hits-per-page :items="[{ label: '1 hits per page', value: 1, default: true },]" style="display: none"></ais-hits-per-page> -->
        <!-- <ais-search-box submit-title="Submit the query" /> -->
        <ais-hits>
          <template v-slot="{ items }">
            <div class="custom-container" v-if="items">
              <div class="shop-wrapper" v-if="items.length">
                <div class="row">
                  <!-- @open-quick-view="openQuickView"
                    @open-add-shopping-list="openAddToShoppingList" -->
                  <ProductThumbnail v-for="item in items" data-test="product-list" :key="item.id"
                    :product="formatProduct(item)" :addToCart="addToCart" />
                </div>
                <!-- <Pagination
                  :total="total"
                  :page="page"
                  :setPage="setPage"
                /> -->
                <!-- TODO -->
              </div>

              <div v-else>
                <div class="empty-results-container">
                  <span class="empty-results" data-test="empty-results">
                    {{ t('notFound') }}
                  </span>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="empty-results-container">
                <span class="empty-results" data-test="category-not-found">
                  {{ t('categoryNotFound') }}
                </span>
              </div>
            </div>
          </template>
        </ais-hits>
        <ais-pagination class="pro-pagination-style text-center">
          <template v-slot="{
            currentRefinement,
            nbPages,
            pages,
            isFirstPage,
            isLastPage,
            refine,
            createURL
          }">
            <ul>
              <li v-if="!isFirstPage">
                <a :href="createURL(0)" @click.prevent="refine(0)" class="next">
                  Previous
                </a>
              </li>
              <!-- <li v-if="!isFirstPage">
        <a
          :href="createURL(currentRefinement - 1)"
          @click.prevent="refine(currentRefinement - 1)"
        >
          �
        </a>
      </li> -->
              <li v-for="page in pages" :key="page">
                <a :href="createURL(page)" :style="{ fontWeight: page === currentRefinement ? 'bold' : '' }"
                  :class="page === currentRefinement ? 'active' : ''" @click.prevent="refine(page)">
                  {{ page + 1 }}
                </a>
              </li>
              <!-- <li v-if="!isLastPage">
        <a
          :href="createURL(currentRefinement + 1)"
          @click.prevent="refine(currentRefinement + 1)"
        >
          �
        </a>
      </li> -->
              <li v-if="!isLastPage">
                <a :href="createURL(nbPages)" @click.prevent="refine(nbPages)" class="next">
                  Next
                </a>
              </li>
            </ul>
          </template>
        </ais-pagination>
      </ais-instant-search>
      <div class="custom-container" v-else-if="products">
        <!-- <TopBar
        v-on:toggle-filter="toggleFilter"
        @change-sort="changeSort"
        v-bind:show="show"
        v-bind:sort="sort"
        v-bind:count="products.count"
        v-bind:offset="products.offset"
        v-bind:total="products.total"
      /> -->
        <!-- <ProductFilter
        :facets="facets"
        :facetFilter="facetFilter"
        @filter-change="facetFilterChange"
        @channel-change="channelChange"
        :allChannels="allChannels"
        v-bind:show="show"
      /> -->
        <div class="shop-wrapper" v-if="products.length">
          <div class="row">
            <!-- @open-quick-view="openQuickView"
            @open-add-shopping-list="openAddToShoppingList" -->
            <ProductThumbnail v-for="product in products" data-test="product-list" :key="product.id"
              :product="formatProduct(product)" :addToCart="addToCart" />
          </div>
          <Pagination :total="total" :page="page" :setPage="setPage" />
        </div>

        <div v-else>
          <div class="empty-results-container">
            <span class="empty-results" data-test="empty-results">
              {{ t('notFound') }}
            </span>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="empty-results-container">
          <span class="empty-results" data-test="category-not-found">
            {{ t('categoryNotFound') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>